export function isConfirmPage(steps: Array<any>, stepIdx: number) {
    if (stepIdx > steps.length - 1) return false;
    if (steps[stepIdx]?.stepId === 'confirmation') return true;
    return false;
}
